import { CriteriaDimension, SortDirection } from '@openx/types/tableCriteria';
import { TABLE_PAGE_SIZE } from '../../config';
import type { DefaultTableCriteria } from '../../utils/useListCriteria';

export const defaultCriteria: DefaultTableCriteria<'organizations'> = {
  [CriteriaDimension.FILTERS]: {
    phrase: '',
  },
  [CriteriaDimension.PAGINATION]: {
    pageNumber: 1,
    pageSize: TABLE_PAGE_SIZE,
    totalCount: 100,
  },
  [CriteriaDimension.SORT]: {
    column: 'created_date',
    direction: SortDirection.DESC,
    sortableColumns: ['name', 'created_date', 'allowed_countries', 'parent_account', 'organization_type'],
    valuePath: {
      parent_account: ['name'],
    },
  },
};
